import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import * as SDK from "./sdk";
import * as OSAWAY from "../app/osaway/locals";
import * as RA from "../app/hla/locals";
import * as CODING from "../app/coding/locals";
import * as NOTIFICATION from "../app/notification/locals";
import * as AUTH from "../app/auth/locals";
import * as ACCOUNT from "../app/account/locals";
import * as HOME from "../app/pages/home/locals";
import * as MAP from "../app/pages/map/locals";
import * as SHARED from "../app/shared/locals";
import * as DEMONSTRATOR from "../app/demonstrator/locals";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {},
    fallbackLng: "en",
    supportedLngs: ["en"],
    debug: false,
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
  });

i18n.addResourceBundle("en", SDK.NAMESPACE, SDK.EN);
i18n.addResourceBundle("en", OSAWAY.NAMESPACE, OSAWAY.EN);
i18n.addResourceBundle("en", RA.NAMESPACE, RA.EN);
i18n.addResourceBundle("en", CODING.NAMESPACE, CODING.EN);
i18n.addResourceBundle("en", NOTIFICATION.NAMESPACE, NOTIFICATION.EN);
i18n.addResourceBundle("en", AUTH.NAMESPACE, AUTH.EN);
i18n.addResourceBundle("en", ACCOUNT.NAMESPACE, ACCOUNT.EN);
i18n.addResourceBundle("en", HOME.NAMESPACE, HOME.EN);
i18n.addResourceBundle("en", MAP.NAMESPACE, MAP.EN);
i18n.addResourceBundle("en", DEMONSTRATOR.NAMESPACE, DEMONSTRATOR.EN);
i18n.addResourceBundle("en", SHARED.NAMESPACE, SHARED.EN);
